import React from 'react';
import { Star, Quote } from 'lucide-react';
import { reviews, companyInfo } from '../mockData';

const Reviews = () => {
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        className={`w-5 h-5 ${
          index < rating
            ? 'fill-yellow-400 text-yellow-400'
            : 'text-gray-300'
        }`}
      />
    ));
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 to-blue-700 text-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Client Reviews
            </h1>
            <p className="text-xl text-blue-100">
              See what our valued clients say about our services.
            </p>
          </div>
        </div>
      </section>

      {/* Rating Overview */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-lg border border-blue-200 text-center">
              <div className="flex items-center justify-center gap-2 mb-4">
                {renderStars(5)}
              </div>
              <div className="text-5xl font-bold text-blue-600 mb-2">
                {companyInfo.rating}
              </div>
              <p className="text-gray-600 text-lg">
                Based on {companyInfo.reviewCount} reviews
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews List */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto space-y-6">
            {reviews.map((review) => (
              <div
                key={review.id}
                className="bg-white rounded-lg shadow-md border border-gray-200 p-8 hover:shadow-xl transition-shadow"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                      {review.name.charAt(0)}
                    </div>
                  </div>

                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900">
                          {review.name}
                        </h3>
                        <p className="text-sm text-gray-600">{review.company}</p>
                      </div>
                      <span className="text-sm text-gray-500">{review.date}</span>
                    </div>

                    <div className="flex items-center gap-1 mb-4">
                      {renderStars(review.rating)}
                    </div>

                    <div className="relative">
                      <Quote className="absolute -top-2 -left-2 w-8 h-8 text-blue-200" />
                      <p className="text-gray-700 leading-relaxed pl-6">
                        {review.text}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Experience Our Quality Service
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Join our satisfied clients and experience professional electrical testing and calibration services.
            </p>
            <a
              href="/contact"
              className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors inline-block shadow-lg"
            >
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;